<template>
  <div class="worldview position-relative">
    <img
      src="../../assets/img/worldview/title.png"
      alt=""
      srcset=""
      class="title"
    />

    <div class="w-cont d-flex align-items-center justify-content-center">
      <img
        src="../../assets/img/worldview/cnt-text.png"
        alt=""
        srcset=""
        class="text"
      />
      <div class="player-bg position-relative">
        <img
          src="../../assets/img/worldview/player.png"
          alt=""
          class="player position-absolute cursor"
          @click="handleShowVideo()"
        />
        <!-- 
        <div
          class="player position-absolute cursor"
          @click="handleShowVideo()"
        ></div> -->
        <div class="ytvideo" v-if="showVideo">
          <iframe
            width="100%"
            height="100%"
           src="https://www.youtube.com/embed/7h2w80lOrgY?si=jzzuj7tPDQkI0iNS"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false
    };
  },
  methods: {
    handleShowVideo() {
      this.showVideo = true;
    },
    closeVideo() {
      this.videoFlag = false;
    }
  }
};
</script>
<style lang="scss">
.worldview {
  height: 1080px;
  width: 100%;

  background-image: url("../../assets/img/worldview/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  .title {
    width: 781px;
    height: auto;
    padding-top: 6vw;
    display: block;
    margin: 0 auto;
  }

  .w-cont {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 2vw;
    gap: 1vw;
    .text {
      width: 700px;
      height: auto;
    }
    .player-bg {
      background: url("../../assets/img/worldview/video-bg.png") no-repeat
        center top;
      background-size: 100% 100%;
      width: 840px;
      height: 484px;

      .player {
        // background: url("../../assets/img/worldview/player.png") no-repeat
        //   center top;
        // background-size: 100% 100%;
        width: 130px;
        height: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .ytvideo {
        width: 816px;
        height: 459px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .videoFlag {
  }
  @keyframes scaleAni1 {
    0% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }

    100% {
      -webkit-transform: scale(1.1);
      -moz-transform: scale(1.1);
      -ms-transform: scale(1.1);
      -o-transform: scale(1.1);
      transform: scale(1.1);
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainComponents/worldview.vue